module.exports = __webpack_public_path__ + "img/example3.68741bb6.jpg";